import { render, staticRenderFns } from "./homeTimelineItem.vue?vue&type=template&id=db964812&scoped=true&"
import script from "./homeTimelineItem.vue?vue&type=script&lang=js&"
export * from "./homeTimelineItem.vue?vue&type=script&lang=js&"
import style0 from "./homeTimelineItem.vue?vue&type=style&index=0&id=db964812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db964812",
  null
  
)

export default component.exports